import StackedPieChart from "../../../../components/stackedPieChart/stackedPieChart";
import { connect } from "react-redux";

export default connect(state => ({
  clickablePie: true,
  data: [
    {
      revenueType: "New",
      revenue: state.studioInfo.membershipActivityValues.data.newMembers,
      url: state.studioInfo.membershipActivityValues.data.newMembersRawDataLink
    },
    {
      revenueType: "Cancelled",
      revenue: state.studioInfo.membershipActivityValues.data.churnMembers,
      url: state.studioInfo.membershipActivityValues.data.churnMembersRawDataLink
    }
  ],
  chartStats: [
    {
      title: "Members",
      value: state.studioInfo.membershipActivityValues.data.activeMembers,
      valueRawDataLink: state.studioInfo.membershipActivityValues.data.activeMembersRawDataLink,
      percentChange: state.studioInfo.membershipActivityValues.data.activeMembersChange
    },
    {
      title: "Frozen Members",
      negIsPositive: true,
      value: state.studioInfo.membershipActivityValues.data.frozenMembers,
      valueRawDataLink: state.studioInfo.membershipActivityValues.data.frozenMembersRawDataLink,
      percentChange: state.studioInfo.membershipActivityValues.data.frozenMembersChange
    }
  ]
}))(StackedPieChart);
